// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-wrapper .progress-bar-container {
  flex: 1 1 0px;
  height: 6px;
  border-radius: 120px;
  background-color: #E7E7E7;
}
.progress-bar-wrapper .progress-bar {
  border-radius: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/progress-bar/style.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,oBAAA;AADJ","sourcesContent":[".progress-bar-wrapper {\n  .progress-bar-container {\n    flex: 1 1 0px;\n    height: 6px;\n    border-radius: 120px;\n    background-color: theme('colors.grey-30');\n  }\n\n  .progress-bar {\n    border-radius: 120px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
